import header from "./couple-planning-house.webp";
import section1 from "./real-estate-agent-gives-keys.png";
import section2 from "./gut-organisierte-vertraege.webp";
import section3 from "./mann-renoviert.png";
import section4 from "./close-up-calculating.png";
import section5 from "./surpised-man-is-reading-newspaper.png";
import section6 from "./real-estate-agent-is-selling-to-couple.png";
import section7 from "./real-estate-agent-is-stamping.png";
import section8 from "./gespraech-mit-kaufinteressenten.webp";
import section9 from "./erfolgreicher-vertragsabschluss.jpg";
import section10 from "./details-mit-notar.jpg";
import section11 from "./stempel-auf-urkunde.jpg";
import section12 from "./schluesseluebergabe.png";
import section13 from "./happy-woman.webp";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
  section8,
  section9,
  section10,
  section11,
  section12,
  section13,
};
